import logoPNG from '../assets/brand/logo-png.png';
import '../css/main.css';
import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Now using URLs instead of section anchors
  // const navLinks = [
  //   { label: 'Home', url: 'http://localhost:3000' },
  //   { label: 'Services', url: 'http://localhost:3000/#/services' },
  //   { label: 'Projects', url: 'http://localhost:3000/#/projects' },
  //   { label: 'Gallery', url: 'http://localhost:3000/#/gallery' },
  //   { label: 'About Us', url: 'http://localhost:3000/#/about' },
  //   { label: 'Contact Us', url: 'http://localhost:3000/#/contacts' },
  // ];

  const navLinks = [
    { label: 'Home', url: 'https://edgesdesigngroup.com/' },
    { label: 'Services', url: 'https://edgesdesigngroup.com/#/services' },
    { label: 'Projects', url: 'https://edgesdesigngroup.com/#/projects' },
    { label: 'Gallery', url: 'https://edgesdesigngroup.com/#/gallery' },
    { label: 'About Us', url: 'https://edgesdesigngroup.com/#/about' },
    { label: 'Contact Us', url: 'https://edgesdesigngroup.com/#/contacts' },
  ];

  return (
    <header className="bg-white shadow-md text-primary-dark fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        <div className="text-2xl font-bold tracking-wide">
          <img src={logoPNG} alt="Logo" className="h-10 w-auto" />
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.url}
              className="text-primary-dark  hover:text-teal-600 transition"
              rel="noopener noreferrer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <button onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 px-4 py-4 space-y-2">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.url}
              className="block text-gray-700 font-medium hover:text-teal-600 transition"
              onClick={() => setMobileOpen(false)}
              rel="noopener noreferrer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}

export default NavBar;
